// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7115) return "static/chunks/7115-8f8c95d8bdad413f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"5460cef137045ca0","2937":"5e6f1007026be5ab"}[chunkId] + ".js";
};